import {
  AvbodenbedeckungService,
  BodenbedeckungMasterDetailEntry,
  BodenbedeckungVersionDetailEntry,
  HistInfo
} from "../av-api";
import {Injectable} from "@angular/core";
import {GrundstueckId} from "../gb-api";
import {TimepointService} from "./timepoint.service";
import {AppConfigService} from "./app-config.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {TranslateNamePipe} from "../../shared/pipes/simple/translate-name.pipe";
import {ComparatorService} from "../../shared/services/comparator-service";
import BodenbedeckungArtEnum = BodenbedeckungVersionDetailEntry.BodenbedeckungArtEnum;


@Injectable()
export class BodenbedeckungViewmodelService {

  private GEBAEUDE = BodenbedeckungArtEnum.GEBAEUDE;

  constructor(private bodenbedeckungService: AvbodenbedeckungService,
              private timepointService: TimepointService,
              private appConfigService: AppConfigService,
              private comparator: ComparatorService,
              private translateName: TranslateNamePipe) {
  }

  public loadBodenbedeckungSichtGrundstueck(grundstueckId: GrundstueckId): Observable<ViewModelBodenbedeckungEntry[]> {
    const z = this.timepointService.timepointCtx;
    return this.bodenbedeckungService.loadBodenbedeckungSichtGrundstueck( //
      grundstueckId.id, //
      z.timepointIso, //
      z.timepointId, //
      this.appConfigService.einstellungHistorischeDaten //
    ).pipe(map(res => {

        const bodenbedeckungenVM = [];
        if (res.bodenbedeckungGebaeude && res.bodenbedeckungGebaeude.flaecheQuadratmeter > 0) {
          const vm = new ViewModelBodenbedeckungEntry(this.GEBAEUDE, null, res.bodenbedeckungGebaeude.flaecheQuadratmeter, res.bodenbedeckungGebaeude.histInfo);
          bodenbedeckungenVM.push({...vm});
        }
      for (const bodenbedeckung of res.bodenbedeckungMasterDetailEntryList.sort(this.comparator.bodenbedeckungComparator)) {
          const versions = bodenbedeckung.versions;
          bodenbedeckung.versions = null;
          if (versions) {
            for (let i = 0; i < versions.length; i++) {
              const value = versions[i];
              let art;
              if (value.bodenbedeckungArt) {
                art = value.bodenbedeckungArt;
              } else if (value.codeBodenbedeckungArt) {
                art = this.translateName.transform(value.codeBodenbedeckungArt.text);
              }
              const vm = new ViewModelBodenbedeckungEntry(art, value.bodenbedeckungArtZusatz, value.flaecheQuadratmeter, value.histInfo);
              bodenbedeckungenVM.push({...vm});
            }
          }
        }
        return bodenbedeckungenVM;
      }
    ));

  }

}


export class ViewModelBodenbedeckungEntry {

  constructor(
    public art: string,
    public bodenbedeckungArtZusatz: string,
    public flaecheQuadratmeter: number,
    public histInfo?: HistInfo,
  ) {
  }


}


export interface ViewModelBodenbedeckungMasterDetailEntry extends BodenbedeckungMasterDetailEntry {
  version: BodenbedeckungVersionDetailEntry;
  art: string;
}
